export default __webpack_public_path__ + "static/18-city-cdfacdf8bfc486f6074122ed66a967ad.png";